/* 版を摺る（2026-10-02・全ページ）：カートに入れたとき、朱の「和」の印を押す。
   テーマの「カートに入れる」も、TOPの「その場でカートへ」（kz-buy）も、どちらも cart:change（baseEvent: variant:add）を出すので、それを合図にする。
   印は引き出しカートが開いたあと、その上（カートの見出しのあたり）に押す。引き出しが無いときは画面の上のほうに。
   最前面に出すため popover（対応していない端末は z-index）を使う。 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const seal = window.kzSealUrl;
  if (!seal) return;
  let el = null;
  const make = () => {
    el = document.createElement('div');
    el.className = 'kz-stamp';
    el.setAttribute('aria-hidden', 'true');
    if ('popover' in HTMLElement.prototype) el.setAttribute('popover', 'manual');
    el.innerHTML = `<img src="${seal}" alt="" width="92" height="92" decoding="sync" loading="eager">`;
    document.body.appendChild(el);
  };
  /* 印の画像は先に読み込んでおく（初めて押したときに白く抜けないように） */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', make, { once: true }); else make();
  const press = () => {
    if (!el) make();
    const drawer = document.getElementById('cart-drawer');
    let x = innerWidth / 2; let y = innerHeight * .3;
    if (drawer) {
      const panel = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part~="content"]');
      const r = (panel || drawer).getBoundingClientRect();
      if (r.width > 0 && r.right > 0 && r.left < innerWidth) { x = r.left + r.width - Math.min(90, r.width * .25); y = r.top + 120; }
    }
    el.style.setProperty('--kz-stamp-x', `${Math.round(x)}px`);
    el.style.setProperty('--kz-stamp-y', `${Math.round(y)}px`);
    el.classList.remove('is-on');
    try { if (el.hasAttribute('popover')) { if (el.matches(':popover-open')) el.hidePopover(); el.showPopover(); } } catch (e) {}
    void el.offsetWidth;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.classList.remove('is-on'); try { if (el.hasAttribute('popover') && el.matches(':popover-open')) el.hidePopover(); } catch (e) {} }, 1700);
  };
  /* 引き出しカートが開ききってから押す（あとから開いた引き出しの下に隠れないように）。開かないときは少し待って押す */
  const isOpen = (d) => d && (d.open === true || d.hasAttribute('open'));
  document.documentElement.addEventListener('cart:change', (e) => {
    const d = e.detail || {};
    if (d.baseEvent !== 'variant:add') return;
    const t0 = performance.now();
    const wait = () => {
      const drawer = document.getElementById('cart-drawer');
      if (isOpen(drawer)) { setTimeout(press, 320); return; }
      if (performance.now() - t0 > 1400) { press(); return; }
      requestAnimationFrame(wait);
    };
    requestAnimationFrame(wait);
  });
})();
